module.exports = __webpack_public_path__ + "assets/151d9123278f53b41cf5fe8d2fa7a755.mp4";